export default "__VITE_ASSET__BTCotI7u__"